












































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { resepStore } from "@/store/modules/resep";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { isEmpty } from "lodash";

import CardResepItems from "@/components/pemeriksaan/resep-obat/CardResepItems.vue";
@Component({
  components: {
    CardResepItems,
  },
})
export default class CardListResep extends Vue {
  @Prop({ default: false }) readOnly!: boolean;

  resepText = "";
  activeResep = {};

  get listResep() {
    return resepStore.resep.filter(item => item.unit.id < "50");
  }

  get loading() {
    return resepStore.listLoading;
  }

  get isEditable() {
    if (this.readOnly) return false;
    return userModule.canAccessForm("permintaan_obat", "edit");
  }

  get canAddResep() {
    if (this.readOnly) return false;
    if (!this.listResep.length) return false;
    return userModule.canAccessForm("permintaan_obat", "create");
  }

  get canAddResepState() {
    if (this.readOnly) return false;
    if (!this.listResep.length) return false;
    return true;
  }

  get register() {
    return this.$route.params.register;
  }

  @Watch("listResep", { deep: true })
  changedListResep() {
    this.resepText = "";
  }

  getListResep() {
    resepStore.getResepByRegister(this.register);
  }

  showResep(resep) {
    this.resepText = resep.text;
    this.activeResep = resep;
  }

  editResep(resep) {
    if (resep.dokter.id == userModule.user.id) {
      this.$emit("set-active-resep", resep);
    } else {
      appModule.sendErrorAlert(
        "Tidak dapat mengedit resep yang ditulis dokter lain"
      );
    }
  }

  addResep() {
    this.$emit("add-resep");
  }

  formatDate(date) {
    return new Intl.DateTimeFormat("id-ID", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(date));
  }

  isEmpty(val) {
    return isEmpty(val);
  }
}
